import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Toaster } from 'react-hot-toast';
import { FaPlusCircle, FaEye, FaPen } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import { IoTrashBin } from "react-icons/io5";
import { Modal } from 'flowbite-react';
import DataTable from 'react-data-table-component';
import { MdDelete } from "react-icons/md";
import def from '../../img/default.png'
import Image from '../../assest/images/37a39cb7092d94d7297953ad09f2dee5.png';

const CreatePharmacy = () => {
    const [openModal, setOpenModal] = useState(false);
    const [rowPerPage, setRowPerPage] = useState(20);
    const [viewModal, setViewModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [items, setItems] = useState([]);
    const [categories, setCategories] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [pharmacy, setPharmacy] = useState(false);
    const [categName, setCategName] = useState({
        categoryName: ""
    });
    const [formData, setFormData] = useState({
        id: "",
        itemName: "",
        description: "",
        price: "",
        discount: 0,
        pharmacyCategory: "",
        item_image: null
    });

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({
                ...prev,
                item_image: file,
                previewImage: URL.createObjectURL(file),
            }));
        }
    };

    const deleteCategory = async (id) => {
        try {
            const response = await axios.delete(`https://backend.amarasinghemedicare.com/pharmacy/deleteCategory/${id}`);

            if (response.status === 202) {
                toast.success("Category deleted successfully!");
                fetchCategories();
            } else {
                toast.error("Something went wrong!");
            }
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.response?.data?.message || "Internal server error!");
        }
    };

    const fetchCategories = () => {
        axios.get('https://backend.amarasinghemedicare.com/pharmacy/pharmacyCategory')
            .then((response) => setCategories(response.data))
            .catch((error) => console.error('Error fetching categories:', error));
    };

    const fetchItems = async () => {
        try {
            const response = await axios.get('https://backend.amarasinghemedicare.com/pharmacy/pharmacy');
            setItems(response.data);
        } catch (error) {
            console.error("Fetch products error :", error);
            toast.error("Failed to load products");
        }
    };

    useEffect(() => {
        fetchItems();
    }, []);

    const handleItemEdit = async (item) => {
        setIsEditMode(true);
        setFormData({
            id: item.id,
            itemName: item.itemName,
            description: item.description,
            price: item.price,
            discount: item.discount,
            pharmacyCategory: item.pharmacyCategory,
            item_image: item.image
        });
        setOpenModal(true);
    };

    const deleteItems = async (id) => {
        try {
            const response = await axios.delete(`https://backend.amarasinghemedicare.com/pharmacy/deleteItem/${id}`);

            if (response.status !== 202) {
                toast.error("Something went wrong");
                return;
            }
            toast.success("Product deleted success");
            fetchItems();
        } catch (error) {
            toast.error("Internal Server Error");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { itemName, description, price, discount, pharmacyCategory, item_image } = formData;

        if (!itemName || !description || !price || !discount || !pharmacyCategory || !item_image) {
            toast.error("Please fill in all fields and upload an image.");
            return;
        }

        const numericPrice = parseFloat(price);
        if (isNaN(numericPrice) || numericPrice <= 0) {
            toast.error("Please enter a valid numeric price greater than 0.");
            return;
        }

        const numericDiscount = parseFloat(discount);
        if (isNaN(numericDiscount) || numericDiscount < 0 || numericDiscount > 100) {
            toast.error("Please enter a valid discount between 0 and 100.");
            return;
        }

        try {
            const form = new FormData();
            form.append("itemName", itemName);
            form.append("description", description);
            form.append("price", price);
            form.append("discount", discount);
            form.append("pharmacyCategory", pharmacyCategory);
            form.append("image", item_image);

            const response = await axios.post('https://backend.amarasinghemedicare.com/pharmacy/createItem', form, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.status === 200) {
                toast.success("Pharmacy item created successfully!");
                fetchItems();
                setFormData({
                    id: "",
                    itemName: "",
                    description: "",
                    price: "",
                    discount: "",
                    pharmacyCategory: "",
                    item_image: null,
                });
            } else {
                toast.error("Failed to create item.");
            }
        } catch (error) {
            console.error("Submit error:", error);
            toast.error(error.response?.data?.message || "Internal Server Error");
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleChangeCategory = (e) => {
        setCategName({
            ...categName,
            [e.target.name]: e.target.value,
        });
    };

    const handleChancel = () => {
        setFormData({
            id: "",
            itemName: "",
            description: "",
            price: "",
            discount: "",
            pharmacyCategory: "",
            item_image: null,
        });
        setPharmacy(false);
        setIsEditMode(false);
        setOpenModal(false);
    };

    const handleCreateCategory = async (e) => {
        e.preventDefault();

        if (!categName.categoryName) {
            toast.error("Failed");
        }

        try {
            const response = await axios.post('https://backend.amarasinghemedicare.com/pharmacy/createCategory', categName);

            if (response.status !== 200 || (!response.data)) {
                toast.error("Something went wrong");
                return;
            }

            toast.success("Pharmacy item created successfully");
            setCategName({
                categoryName: ""
            });
            setPharmacy(false);
            fetchCategories();
        } catch (error) {
            toast.error("Please check before submitting");
        }
    };

    const handleOpenModal = () => {
        setOpenModal(true);
        fetchCategories();
    };

    const columns = [
        { name: 'Category', selector: row => row.category, sortable: true },
        {
            name: 'Action',
            cell: row => (
                <div className="flex space-x-3 justify-center items-center">
                    <button onClick={(e) => { e.preventDefault(); deleteCategory(row.id); }} className="flex items-center justify-center align-middle font-semibold p-[6px] rounded-md shadow-md shadow-slate-400/50 outline-1  outline-slate-500  bg-red text-white hover:bg-green-500 transform transition-transform duration-300 hover:scale-105">
                        <MdDelete className='text-sm' />
                    </button>
                </div>
            ),
            width: '100px',
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#E5E7EB',
                color: 'black',
                fontWeight: 'bold',
                fontSize: '13px',
            },
        },
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();

        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        const isFile = formData.item_image && typeof formData.item_image !== 'string';

        if (isFile && !allowedTypes.includes(formData.item_image.type)) {
            toast.error("Only JPG, JPEG, and PNG formats are allowed");
            return;
        }

        const payload = new FormData();
        payload.append('id', formData.id);
        payload.append('itemName', formData.itemName);
        payload.append('description', formData.description);
        payload.append('price', formData.price);
        payload.append('discount', formData.discount);
        payload.append('pharmacyCategory', formData.pharmacyCategory);

        if (isFile) {
            payload.append('item_image', formData.item_image);
        } else {
            payload.append('existingImage', formData.item_image);
        }

        try {
            const response = await axios.patch('https://backend.amarasinghemedicare.com/pharmacy/editItem', payload,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                }
            );

            if (response.status === 200) {
                toast.success("Item has been updated");
                fetchItems();
                setFormData({
                    id: "",
                    itemName: "",
                    description: "",
                    price: "",
                    discount: "",
                    pharmacyCategory: "",
                    item_image: null,
                });
                setOpenModal(false);
            }
        } catch (error) {
            toast.error("Failed to update item!");
            console.error("Error:", error);
        }
    };

    return (
        <div className="p-5">
            <Toaster />
            <div className='flex justify-between items-center mb-2'>
                <h1 className="text-md sm:text-lg md:text-2xl font-bold">Pharmacy Items</h1>

                <button onClick={handleOpenModal} className='text-sm sm:text-md md:text-[16px] text-white uppercase font-semibold text-left bg-[#97CE4F] p-2 rounded-lg transform transition-transform duration-300 hover:scale-105'>Create Pharmacy Item</button>
            </div>

            <div className="flex flex-wrap">
                {items.length > 0 ? (
                    items.map((item) => (
                        <div className="mb-10 px-5 mt-5 w-full sm:w-1/2 md:w-1/3">
                            <div className="h-full p-5 bg-white flex flex-col items-center justify-between rounded-lg shadow-md gap-4">
                                <div className='w-full flex justify-center items-center'>
                                    <img
                                        className="w-32 h-32 sm:w-42 sm:h-42 md:w-full md:h-64 object-cover"
                                        src={`https://backend.amarasinghemedicare.com/Upload/Pharmacy/${item.image}`}
                                        alt={item.itemName}
                                    />
                                </div>

                                <div className="flex flex-col items-start justify-start w-full flex-grow">
                                    <h3 className='text-sm font-extralight'>{item.category}</h3>
                                    <h1 className="text-base font-semibold text-fontDark">{item.itemName}</h1>
                                    <p className="text-sm">
                                        {item.description.length > 100
                                            ? item.description.slice(0, 50) + "..."
                                            : item.description}
                                    </p>
                                    <h1 className="text-base font-semibold text-fontDark mt-2 flex gap-2 items-center justify-center">
                                        {
                                            item.discount === 0 ? (
                                                <span>රු{Number(item.price).toFixed(2)}</span>
                                            ) : (
                                                <div className="">
                                                    <span className="line-through mr-2 text-gray-400">රු{Number(item.price).toFixed(2)}</span>
                                                    <span className="font-bold text-red">රු{Number(item.price - (item.price * (item.discount / 100))).toFixed(2)}</span>
                                                </div>
                                            )
                                        }
                                    </h1>
                                    <h3
                                        className="text-sm mt-3 cursor-pointer text-blue-500 hover:underline flex gap-1 items-center justify-center"
                                        onClick={() => {
                                            toast.success('Copied to clipboard');
                                        }}
                                    >
                                        <IoLogoWhatsapp className='text-[#25D366] text-3xl' /> Ask for More Info
                                    </h3>
                                </div>

                                <div className='flex w-full justify-center items-center gap-2'>
                                    <button type='button' onClick={() => { setSelectedItem(item); setViewModal(true); }} className="mt-auto flex items-center justify-center text-sm text-white uppercase font-light bg-[#97CE4F] py-2 w-full rounded-lg transform transition-transform duration-300 hover:scale-105">
                                        <FaEye className='text-md' />
                                    </button>

                                    <button type='button' onClick={() => handleItemEdit(item)} className="mt-auto flex items-center justify-center text-sm text-white uppercase font-light bg-blue py-2 w-full rounded-lg transform transition-transform duration-300 hover:scale-105">
                                        <FaPen className='text-md' />
                                    </button>

                                    <button type='button' onClick={() => deleteItems(item.id)} className="mt-auto flex items-center justify-center text-sm text-white uppercase font-light bg-red py-2 w-full rounded-lg transform transition-transform duration-300 hover:scale-105">
                                        <IoTrashBin className='text-md' />
                                    </button>
                                </div>


                            </div>
                        </div>

                    ))
                ) : (
                    <div>
                        No item found
                    </div>
                )}
            </div>

            <Modal size='md' show={openModal} onClose={handleChancel} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900">{isEditMode ? "Edit" : "Add"} {isEditMode ? "" : (<span className='text-red'>New</span>)}  Pharmacy Item</h3>
                        <form
                            onSubmit={isEditMode ? handleEditSubmit : handleSubmit}
                            className=""
                        >
                            <div className="">
                                <div>
                                    <label htmlFor="itemName" className="table-row text-[#261C53] text-[15px]">Item Name :</label>
                                    <input
                                        type="text"
                                        id="itemName"
                                        name="itemName"
                                        value={formData.itemName}
                                        onChange={handleChange}
                                        className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                                    />
                                </div>

                                <div className="mt-4">
                                    <label htmlFor="description" className="table-row text-[#261C53] text-[15px]">Description :</label>
                                    <textarea
                                        type="text"
                                        id="description"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                        className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                                    />
                                </div>
                            </div>

                            <div className="mt-4 flex items-center justify-start gap-3">
                                <div>
                                    <label htmlFor="price" className="table-row text-[#261C53] text-[15px]">Price :</label>
                                    <input
                                        type="text"
                                        id="price"
                                        name="price"
                                        value={formData.price}
                                        onChange={handleChange}
                                        className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                                    />
                                </div>

                                <div className="">
                                    <label htmlFor="discount" className="table-row text-[#261C53] text-[15px]">Discount :</label>
                                    <div className='flex justify-center items-center gap-1 text-red font-semibold'>
                                        <input
                                            type="number"
                                            min={0}
                                            max={100}
                                            id="discount"
                                            name="discount"
                                            value={formData.discount}
                                            onChange={handleChange}
                                            onKeyPress={(e) => e.preventDefault()}
                                            className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                                        />
                                        %
                                    </div>
                                </div>
                            </div>

                            <div className='mt-4'>
                                <button type='button' onClick={() => setPharmacy(true)} className='text-[16px] text-white uppercase font-semibold text-left bg-blue p-2 rounded-lg transform transition-transform duration-300 hover:scale-105 flex items-center justify-center gap-2'><FaPlusCircle className='text-xl font-extrabold' /> Create Category</button>

                                {pharmacy && (
                                    <div className='px-4 py-3 mt-4 bg-fontDark rounded-lg border-green border-[5px]'>
                                        <label htmlFor="categoryName" className="table-row text-white text-[15px]">Category Name :</label>
                                        <input
                                            type="text"
                                            id="categoryName"
                                            name="categoryName"
                                            value={categName.categoryName}
                                            placeholder='Enter new category name'
                                            onChange={handleChangeCategory}
                                            className="w-full p-3 bg-white border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                                        />

                                        <div className='flex justify-end items-center h-10 mt-5 gap-3'>
                                            <button
                                                type='button'
                                                onClick={() => setPharmacy(false)}
                                                className='text-[16px] text-white uppercase font-semibold text-left bg-red p-2 rounded-lg transform transition-transform duration-300 hover:scale-105'
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type='button'
                                                onClick={handleCreateCategory}
                                                className='text-[16px] text-white uppercase font-semibold text-left bg-blue p-2 rounded-lg transform transition-transform duration-300 hover:scale-105'
                                            >
                                                Create
                                            </button>
                                        </div>

                                        <div className='my-4 px-5'>
                                            <DataTable
                                                columns={columns}
                                                data={categories}
                                                fixedHeader
                                                fixedHeaderScrollHeight="80vh"
                                                className="data-table"
                                                customStyles={customStyles}
                                                pagination
                                                paginationPerPage={rowPerPage}
                                                paginationRowsPerPageOptions={[10, 20, 50, 100, 200]}
                                                onChangeRowsPerPage={(newRowsPerPage) => { setRowPerPage(newRowsPerPage) }}
                                            />
                                        </div>
                                    </div>
                                )}

                            </div>

                            <div className="my-4">
                                <label htmlFor="pharmacyCategory" className="table-row text-[#261C53] text-[15px]">Item Category :</label>

                                <select
                                    name="pharmacyCategory"
                                    id="pharmacyCategory"
                                    value={formData.pharmacyCategory}
                                    onChange={handleChange}
                                    className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                                >
                                    <option value="" disabled className="text-gray-700">
                                        Select Category
                                    </option>

                                    {categories.length > 0 ? (
                                        categories.map((category) => (
                                            <option key={category.id} value={category.id} className="text-black bg-white">
                                                {category.category}
                                            </option>
                                        ))
                                    ) : (
                                        <option value="null" disabled>No Categories found</option>
                                    )}
                                </select>
                            </div>

                            <label htmlFor="pharmacyCategory" className="table-row text-[#261C53] text-[15px]">Default Image:</label>
                            {isEditMode ? (
                                <img
                                    src={
                                        formData.previewImage
                                            ? formData.item_image
                                            : formData.item_image && typeof formData.item_image === 'string'
                                                ? `https://backend.amarasinghemedicare.com/Upload/Pharmacy/${formData.item_image}`
                                                : def
                                    }
                                    alt="Profile"
                                    className="w-32 h-32 object-cover border-black border-[1px]"
                                />
                            ) : ''
                            }

                            <div className="">
                                <div className="flex mt-6 space-x-4">
                                    <div className="w-full">
                                        <label htmlFor="profile_image" className="table-row text-[#261C53] text-[15px]">Item Image:</label>
                                        <input
                                            type="file"
                                            id="profile_image"
                                            name="profile_image"
                                            onChange={handleFileChange}
                                            className="w-full p-3 bg-gray-200 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='flex justify-end items-center h-10 mt-5 gap-3'>
                                <button onClick={handleChancel} className='text-[16px] text-white uppercase font-semibold text-left bg-red p-2 rounded-lg transform transition-transform duration-300 hover:scale-105'>Cancel</button>
                                <button type='submit' className='text-[16px] text-white uppercase font-semibold text-left bg-[#97CE4F] p-2 rounded-lg transform transition-transform duration-300 hover:scale-105'>
                                    {isEditMode ? 'Update' : 'Submit'}
                                </button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal size='lg' show={viewModal} onClose={() => { setSelectedItem(null); setViewModal(false); }} popup>
                <Modal.Header />
                <Modal.Body>
                    {selectedItem && (
                        <div className="flex flex-col md:flex-row gap-5">
                            <div className="w-full md:w-1/2 md:h-[500px] flex justify-center items-center border border-fontDark rounded-xl">
                                <img
                                    src={`https://backend.amarasinghemedicare.com/Upload/Pharmacy/${selectedItem.image}`}
                                    alt={selectedItem.itemName}
                                    className="object-cover h-full rounded-lg"
                                />
                            </div>

                            <div className="w-full md:w-1/2 flex flex-col gap-3 justify-center">
                                <div className='flex items-center justify-center gap-3 bg-yellow-400 p-4 rounded-2xl shadow-lg mb-4 flex-col sm:flex-row md:flex-row'>
                                    <div className='w-44 md:w-96 rounded-full p-4 overflow-hidden bg-white'>
                                        <img className='w-full' src={Image} alt="" />
                                    </div>


                                    <div className='flex flex-col gap-3'>
                                        <h1 className='text-base'>අමරසිංහ වෛද්‍ය මධ්‍යස්ථානයට පැමිණීමෙන් ඔබට අවශ්‍ය සියලුම ඖෂධ සහ වෛද්‍ය උපකරණ අවම මිලට පහසුවෙන් ලබා ගත හැකිය. වැඩි විස්තර සඳහා පහත WhatsApp අංකය අමතන්න.</h1>
                                        <h1 className='text-sm'>You can easily get all the medicines and medical equipment you need at the lowest price by visiting Amarasinghe Medical Centre. For more information, contact the WhatsApp number below.</h1>
                                    </div>
                                </div>

                                <div>
                                    <h3 className='text-sm font-extralight'>{selectedItem.category}</h3>
                                    <h1 className="text-xl font-semibold text-blue">{selectedItem.itemName}</h1>
                                    <p className="text-sm text-gray-950 mt-2">{selectedItem.description}</p>

                                    <h1 className="text-base font-semibold text-fontDark mt-2 flex gap-2 items-center">
                                        {
                                            selectedItem.discount === 0 ? (
                                                <span>රු{Number(selectedItem.price).toFixed(2)}</span>
                                            ) : (
                                                <div className="">
                                                    <span className="line-through mr-2 text-gray-400">රු{Number(selectedItem.price).toFixed(2)}</span>
                                                    <span className="font-bold text-red">රු{Number(selectedItem.price - (selectedItem.price * (selectedItem.discount / 100))).toFixed(2)}</span>
                                                </div>
                                            )
                                        }
                                    </h1>

                                    <h3
                                        className="text-sm font-semibold text-white mt-3 cursor-pointer text-blue-500 transition-transform duration-300 hover:scale-105 flex gap-1 items-center w-fit p-2 bg-[#25D366] rounded-3xl"
                                        onClick={() => {
                                            toast.success('Copied to clipboard');
                                        }}
                                    >
                                        <IoLogoWhatsapp className='text-white text-3xl' /> Ask for More Info
                                    </h3>
                                </div>


                            </div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default CreatePharmacy;
